export const stickDate = (values, date, field) => ({
    ...values,
    [field]: `${date.year}-${date.month}-${date.day}T${date.hour}:${date.minute}:${date.second}`,
});
